import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Header from './components/elem/Header'

import UserContextProvider from './components/wrappers/UserContext'
import APIRequestContextProvider from './components/wrappers/APIRequestContext'

import urls from './utils/constants/urls'

import GlobalStyle from './theme/GlobalStyle'
import FormStateContextProvider, {
    FormStateContext,
} from './components/wrappers/FormStateContext'
import AsyncPage from './components/wrappers/AsyncPage'
import routePaths from './utils/constants/routePaths'
import EditorAccess from './components/features/user/EditorAccess'
import ViewerAccess from './components/features/user/ViewerAccess'

function App() {
    return (
        <React.Fragment>
            <GlobalStyle />
            <Header />
            <div className="contentWrapper">
                <Router>
                    <UserContextProvider>
                        <APIRequestContextProvider>
                            <FormStateContextProvider>
                                <Routes>
                                    <Route
                                        exact
                                        path={urls.userCallback}
                                        element={
                                            <AsyncPage
                                                page={routePaths.callback}
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/"
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage
                                                    page={routePaths.landing}
                                                />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/modules/:moduleName"
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage
                                                    page={routePaths.modules}
                                                />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/entities"
                                        element={
                                            <AsyncPage
                                                page={routePaths.entities}
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/wells"
                                        element={
                                            <AsyncPage
                                                page={routePaths.wells}
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/uicPermits"
                                        element={
                                            <AsyncPage
                                                page={routePaths.uicPermits}
                                            />
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/entity/new'}
                                        element={
                                            <EditorAccess>
                                                <AsyncPage
                                                    page={routePaths.entity}
                                                />
                                            </EditorAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/well/new'}
                                        element={
                                            <EditorAccess>
                                                <AsyncPage
                                                    page={routePaths.well}
                                                />
                                            </EditorAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/uicPermit/new'}
                                        element={
                                            <EditorAccess>
                                                <AsyncPage
                                                    page={routePaths.uicPermit}
                                                />
                                            </EditorAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/entity/:entityId'}
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage
                                                    page={routePaths.entity}
                                                />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/well/:facilityId'}
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage
                                                    page={routePaths.well}
                                                />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/uicPermit/:permitId'}
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage
                                                    page={routePaths.uicPermit}
                                                />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/epa-7520-reports"
                                        element={
                                            <AsyncPage
                                                page={routePaths.epa7520reports}
                                            />
                                        }
                                    />
                                    <Route
                                        path="/login"
                                        element={
                                            <AsyncPage
                                                page={routePaths.login}
                                            />
                                        }
                                    />
                                </Routes>
                            </FormStateContextProvider>
                        </APIRequestContextProvider>
                    </UserContextProvider>
                </Router>
            </div>
            <ToastContainer />
        </React.Fragment>
    )
}

export default App
